const admy = {
  // ── SeoPage ──
  "admy.seo_keywords_ph": "Mot-clé1, Mot-clé2, Mot-clé3",

  // ── SocialPage placeholders ──
  "admy.eg_followers": "p.ex. 12.4k",
  "admy.eg_posts": "p.ex. 238",
  "admy.eg_likes": "p.ex. 48.6k",
  "admy.eg_shortcode": "p.ex. CxG7kPqLmN3",

  // ── TranslationsPage group names ──
  "admy.grp_nav": "Navigation",
  "admy.grp_hero": "Accueil Hero",
  "admy.grp_services": "Prestations",
  "admy.grp_about": "À propos",
  "admy.grp_pricing": "Tarifs",
  "admy.grp_booking": "Réservation",
  "admy.grp_footer": "Pied de page",
  "admy.grp_gallery": "Galerie",
  "admy.grp_team": "Équipe",
  "admy.grp_clinic": "Clinique",
  "admy.grp_process": "Processus",
  "admy.grp_trust": "Confiance",
  "admy.grp_dental": "Dentaire",
  "admy.grp_overview": "Aperçu",
  "admy.grp_implants": "Implants",
  "admy.grp_contact": "Contact",
  "admy.grp_seo": "SEO",
  "admy.grp_admin": "Admin",
  "admy.grp_privacy": "Confidentialité",
  "admy.grp_imprint": "Mentions légales",
  "admy.grp_agb": "CGV",
  "admy.grp_language": "Langues",
  "admy.grp_service_detail": "Détail du service",
  "admy.grp_instagram": "Instagram",

  // ── PageEditorPage field labels (home) ──
  "admy.f_hero_line1": "Hero — Ligne 1",
  "admy.f_hero_line2": "Hero — Ligne 2",
  "admy.f_hero_subtitle": "Hero — Sous-titre",
  "admy.f_hero_cta": "Hero — Bouton CTA",
  "admy.f_services_tag": "Prestations — Étiquette",
  "admy.f_services_heading": "Prestations — Titre",
  "admy.f_services_subtitle": "Prestations — Sous-titre",
  "admy.f_hair_title": "Greffe de cheveux — Titre",
  "admy.f_hair_desc": "Greffe de cheveux — Description",
  "admy.f_dental_title": "Cosmétique dentaire — Titre",
  "admy.f_dental_desc": "Cosmétique dentaire — Description",
  "admy.f_botox_title": "Botox & fillers — Titre",
  "admy.f_botox_desc": "Botox & fillers — Description",
  "admy.f_services_cta": "Prestations — Texte CTA",
  "admy.f_about_tag": "À propos — Étiquette",
  "admy.f_about_line1": "À propos — Ligne 1",
  "admy.f_about_line2": "À propos — Ligne 2",
  "admy.f_about_desc": "À propos — Description",
  "admy.f_about_cta": "À propos — CTA",
  "admy.f_pricing_tag": "Tarifs — Étiquette",
  "admy.f_pricing_line1": "Tarifs — Ligne 1",
  "admy.f_pricing_line2": "Tarifs — Ligne 2",
  "admy.f_pricing_subtitle": "Tarifs — Sous-titre",
  "admy.f_pricing_cta": "Tarifs — CTA",
  "admy.f_testimonials_tag": "Avis — Étiquette",
  "admy.f_testimonials_heading": "Avis — Titre",
  "admy.f_testimonials_subtitle": "Avis — Sous-titre",
  "admy.f_testimonial1_text": "Avis 1 — Texte",
  "admy.f_testimonial1_name": "Avis 1 — Nom",
  "admy.f_testimonial1_role": "Avis 1 — Rôle",
  "admy.f_testimonial2_text": "Avis 2 — Texte",
  "admy.f_testimonial2_name": "Avis 2 — Nom",
  "admy.f_testimonial2_role": "Avis 2 — Rôle",
  "admy.f_testimonial3_text": "Avis 3 — Texte",
  "admy.f_testimonial3_name": "Avis 3 — Nom",
  "admy.f_testimonial3_role": "Avis 3 — Rôle",
  "admy.f_testimonial4_text": "Avis 4 — Texte",
  "admy.f_testimonial4_name": "Avis 4 — Nom",
  "admy.f_testimonial4_role": "Avis 4 — Rôle",
  "admy.f_testimonial5_text": "Avis 5 — Texte",
  "admy.f_testimonial5_name": "Avis 5 — Nom",
  "admy.f_testimonial5_role": "Avis 5 — Rôle",
  "admy.f_booking_tag": "Réservation — Étiquette",
  "admy.f_booking_line1": "Réservation — Ligne 1",
  "admy.f_booking_line2": "Réservation — Ligne 2",
  "admy.f_booking_desc": "Réservation — Description",
  "admy.f_booking_cta": "Réservation — CTA",
  "admy.f_process_tag": "Processus — Étiquette",
  "admy.f_process_heading": "Processus — Titre",
  "admy.f_process_subtitle": "Processus — Sous-titre",
  "admy.f_trust_tag": "Confiance — Étiquette",
  "admy.f_trust_heading": "Confiance — Titre",
  "admy.f_trust_subtitle": "Confiance — Sous-titre",
  "admy.f_instagram_heading": "Instagram — Titre",
  "admy.f_instagram_cta": "Instagram — CTA",
  "admy.f_footer_company": "Pied de page — Nom de l'entreprise",
  "admy.f_footer_address": "Pied de page — Adresse",
  "admy.f_footer_phone": "Pied de page — Téléphone",
  "admy.f_footer_email": "Pied de page — E-mail",
  "admy.f_img_hero_bg": "Image — Arrière-plan Hero",
  "admy.f_img_hair": "Image — Greffe de cheveux",
  "admy.f_img_dental": "Image — Cosmétique dentaire",
  "admy.f_img_botox": "Image — Botox & fillers",
  "admy.f_img_about_team": "Image — Équipe À propos",
  "admy.f_img_cta_bg": "Image — Arrière-plan CTA",
  "admy.f_img_process_bg": "Image — Arrière-plan Processus",
  "admy.f_img_trust_bg": "Image — Arrière-plan Confiance",
  "admy.f_img_instagram_1": "Image — Instagram 1",
  "admy.f_img_instagram_2": "Image — Instagram 2",
  "admy.f_img_instagram_3": "Image — Instagram 3",
  "admy.f_img_instagram_4": "Image — Instagram 4",

  // ── shared / about ──
  "admy.f_tag": "Étiquette",
  "admy.f_headline_line1": "Titre Ligne 1",
  "admy.f_headline_line2": "Titre Ligne 2",
  "admy.f_description": "Description",
  "admy.f_quote": "Citation",
  "admy.f_name": "Nom",
  "admy.f_position": "Poste",
  "admy.f_mission_title": "Mission — Titre",
  "admy.f_mission_text": "Mission — Texte",
  "admy.f_values_title": "Valeurs — Titre",
  "admy.f_values_text": "Valeurs — Texte",
  "admy.f_why_albania_title": "Pourquoi l'Albanie — Titre",
  "admy.f_why_albania_text": "Pourquoi l'Albanie — Texte",
  "admy.f_cta_heading": "CTA — Titre",
  "admy.f_cta_subtitle": "CTA — Sous-titre",
  "admy.f_cta_button": "CTA — Bouton",
  "admy.f_img_hero_bg_tirana": "Image — Arrière-plan Hero (Tirana)",
  "admy.f_img_doctor": "Image — Photo Équipe/Médecin",
  "admy.f_img_mission": "Image — Mission",
  "admy.f_img_clinic": "Image — Clinique",

  // ── services ──
  "admy.f_headline": "Titre",
  "admy.f_subtitle": "Sous-titre",
  "admy.f_hair_text": "Greffe de cheveux — Texte",
  "admy.f_hair_price": "Greffe de cheveux — Prix",
  "admy.f_dental2_title": "Dentaire — Titre",
  "admy.f_dental2_text": "Dentaire — Texte",
  "admy.f_dental2_price": "Dentaire — Prix",
  "admy.f_botox2_title": "Botox — Titre",
  "admy.f_botox2_text": "Botox — Texte",
  "admy.f_botox2_price": "Botox — Prix",
  "admy.f_surgery_title": "Chirurgie — Titre",
  "admy.f_surgery_text": "Chirurgie — Texte",
  "admy.f_surgery_price": "Chirurgie — Prix",
  "admy.f_cta_text": "Texte CTA",
  "admy.f_cta_subtitle2": "Sous-titre CTA",
  "admy.f_img_dental2": "Image — Dentaire",
  "admy.f_img_botox2": "Image — Botox",
  "admy.f_img_surgery": "Image — Chirurgie",

  // ── pricing ──
  "admy.f_essential_title": "Essential — Titre",
  "admy.f_essential_price": "Essential — Prix",
  "admy.f_essential_desc": "Essential — Description",
  "admy.f_essential_features": "Essential — Caractéristiques (séparées par des virgules)",
  "admy.f_premium_title": "Premium — Titre",
  "admy.f_premium_price": "Premium — Prix",
  "admy.f_premium_desc": "Premium — Description",
  "admy.f_premium_features": "Premium — Caractéristiques (séparées par des virgules)",
  "admy.f_luxe_title": "Luxe — Titre",
  "admy.f_luxe_price": "Luxe — Prix",
  "admy.f_luxe_desc": "Luxe — Description",
  "admy.f_luxe_features": "Luxe — Caractéristiques (séparées par des virgules)",
  "admy.f_exclusif_title": "Exclusif — Titre",
  "admy.f_exclusif_price": "Exclusif — Prix",
  "admy.f_exclusif_desc": "Exclusif — Description",
  "admy.f_exclusif_features": "Exclusif — Caractéristiques (séparées par des virgules)",
  "admy.f_guarantee_text": "Texte de garantie",
  "admy.f_img_essential": "Image — Forfait Essential",
  "admy.f_img_premium": "Image — Forfait Premium",
  "admy.f_img_luxe": "Image — Forfait Luxe",
  "admy.f_img_exclusif": "Image — Forfait Exclusif",

  // ── booking ──
  "admy.f_hero_subtitle2": "Sous-titre Hero",
  "admy.f_form_title": "Formulaire — Titre",
  "admy.f_form_subtitle": "Formulaire — Sous-titre",
  "admy.f_form_firstname": "Formulaire — Libellé Prénom",
  "admy.f_form_lastname": "Formulaire — Libellé Nom",
  "admy.f_form_email": "Formulaire — Libellé E-mail",
  "admy.f_form_phone": "Formulaire — Libellé Téléphone",
  "admy.f_form_service": "Formulaire — Libellé Traitement",
  "admy.f_form_message": "Formulaire — Libellé Message",
  "admy.f_form_privacy": "Formulaire — Texte Confidentialité",
  "admy.f_success_title": "Succès — Titre",
  "admy.f_success_message": "Succès — Message",
  "admy.f_contact_tag": "Contact — Étiquette",
  "admy.f_contact_heading": "Contact — Titre",
  "admy.f_contact_subtitle": "Contact — Sous-titre",

  // ── team ──
  "admy.f_cta_headline": "Titre CTA",
  "admy.f_cta_subtitle3": "Sous-titre CTA",
  "admy.f_cta_button2": "Bouton CTA",
  "admy.f_show_more": "Afficher plus",
  "admy.f_show_less": "Afficher moins",

  // ── gallery ──
  "admy.f_filter_all": "Filtre — Tous",
  "admy.f_filter_dental": "Filtre — Dentaire",
  "admy.f_filter_surgery": "Filtre — Chirurgie",
  "admy.f_filter_hair": "Filtre — Cheveux",
  "admy.f_filter_aesthetic": "Filtre — Esthétique",
  "admy.f_before_label": "Libellé Avant",
  "admy.f_after_label": "Libellé Après",
};

export default admy;
